/**
 * 工作流通用方法
 */
 import {
  workFlowNext,
  queryVirtualId,
  startProcess,
  getTaskId,
  workFlowDetail,
  stopProcess,
  processInfo,
  queryUploadFileExtensionElements,
  taskTransfer,
  processForm,
  getTaskIdByProcessInsId,
  completeTask,
  backStepList,
  saveTaskProcess,
  queryProcessDefinedId,
  rollBackNode,
  setFlowParams
 } from "@/api/workFlow/workFlow";
import moment from "moment";
import { mapGetters } from "vuex";
import Cookies from "js-cookie";

import { dateFormat } from '@/util/date'

// 打印方法引入
// import Print from '@/views/plugin/workflow/util/print'
export default {
  data() {
    return {
      // 上一个页面的id
      paramsId:'',
      // 核定额度按钮是否想
      showQuotaBtn: false,

      dataReady: false,
      // 流程定义ID
      processDefinedId: '',      
      // 配置表单数据
      auditFormData: {},
      // 打印配置表单
      printFormConfig: {},
      // 会签意见数据
      commentList: [],
      // 流程记录数据
      flowData: [],      
      // 传入文件权限显示列表
      permissionList: [],
      // 流程详情数据
      processDetail: {},
      // 流程图传参
      bpmnOption: {},
      // 保存的数据
      taskSaveData: {},
      // 当前流程状态
      auditStatus: '',
      // 当前流程数据
      presentFlow: {},
      // 传入文件上传组件
      uploadPermissionNameOne: '',
      uploadPermissionNameTwo: '',
      //发起流程得名字
      flowProcessName:'',
      commentBlockConfig: {
        infoTitle: '会签意见',
        infoContent: [{
          title: '',
          prop: 'comment'
        }]
      },
      // 移动端表单配置
      mobileFormData: {},
      // 移动端监控表单数据变化
      mobileFormChange: [],
      mobileFormConifg: [],
      
      // 新增页面公共附件和会签意见container配置
      fileConfig: {
        infoTitle: '公共附件',
        infoContent: [{
          title: '',
          prop: 'fileInfo'
        }]
      },
      commentConfig: {
        infoTitle: '会签意见区',
        infoContent: [{
          title: '',
          prop: 'commentInfo'
        }]
      }

    }
  },
  computed: {
    ...mapGetters(["userInfo", "workFlowData", "tag", "flowData"]),
  },  
  beforeRouteEnter(to, from, next) {
    next(vm=>{
      vm.paramsId = from.params.id;
    })
  },
  methods: {
    dateFormat,

    /**
     * 集成详情页查询流程详情方法
     * 
     * */ 
    async queryFlowTaskDetail(flowableId, auditStatus) {
      // this.getBasicConfigData()
      // this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
      // 获取当前流程文件上传列表权限 permissionList
      // this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
      // 设置流程表单路径
      // this.queryProcessFormDetail(this.processDefinedId)

      // 查询流程数据
      this.auditStatus = auditStatus
      this.$store.commit('SET_WORKFLOW_STATE', {state: auditStatus})
      if(flowableId != '') {
        this.isStartedProcess = true
        // 集成在workFlow.js中
        await this.queryFlowData(flowableId)
      } else {
        // 未启动流程 查询第一个节点的文件上传权限
        this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
        this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
        // 设置流程表单路径
        this.queryProcessFormDetail(this.processDefinedId)
      }
    },

    async getBasicConfigData() {
      this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
      // 获取当前流程文件上传列表权限 permissionList
      this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
      // 设置流程表单路径
      this.queryProcessFormDetail(this.processDefinedId)
    },

    fileChange(fileList) {
      let self = this
      if(fileList.length > 0) {
        this.attchmentList = []
        fileList.map(item => {
          self.attchmentList.push({
            name: item.name,
            url: item.response.data.link
          })
        })
      }
    },

    /**
     * 打开打印表单
     * @param {string} key 指定表单页面参数
     * @param {string} id 项目ID
     *  */
    openPrintForm(key,id) {
      let token = Cookies.get('saber-access-token')
      let printUrl = ''
      // if(window.location.origin.indexOf('dev')> -1){
      //   printUrl = `http://192.168.12.188:8819/jmreport/view/${key}?id=${id}&token=${token}`
      // }else{
      //   printUrl = `${window.location.origin}/jmreport/view/${key}?id=${id}&token=${token}`
      // }

      if(process.env.NODE_ENV === "development") {
        printUrl = `http://192.168.12.188:8819/jmreport/view/${key}?id=${id}&token=${token}`
      }else {
        printUrl = `${window.location.origin}/jmreport/view/${key}?id=${id}&token=${token}`
      }
      window.open(printUrl, '_blank')
    },

    /**
     * 处理流程表单数据
     * @param {Object} customData 自定义组件数据
     * @param {Object} formData 默认组件数据
     */
     dealAuditForm(formData, customData) {
      let self = this
      customData.map(item => {
        if(item.component == 'wf-user-opinion' || item.component == 'wf-users-opinion') {
          formData[item.prop] = item.value?item.value:''
          if(self.$refs.auditInfo) {
            self.$refs.auditInfo.setFormData(item.prop, item.value?item.value: '')
          }
        }
      })
      return formData
     },

    /**
     * 处理组件传参相关数据
     * @param {string} flowableId 流程实例ID
     */
    async queryFlowData(flowableId){
      let self = this
      return new Promise(async (resolve, reject) => {
        // 通过flowableId获取流程配置
        let processDetail = await self.queryTaskDetail(flowableId)
        // 流程记录数据
        self.flowData = processDetail.flowData
        self.$store.commit('SET_WORKFLOW_FLOWDATA', self.flowData)
        // 会签意见数据
        self.commentList = processDetail.commentList?processDetail.commentList:[]
        // 当无taskForm时，取process中variables的值
        if(!processDetail.processDetail.form.taskForm) {
          processDetail.processDetail.form.variables = processDetail.processDetail.process.variables
        }
        self.auditFormData = processDetail.processDetail.form?processDetail.processDetail.form:{}

        // 设置打印表单配置
        self.printFormConfig = self.auditFormData.allPrintAppForm?JSON.parse(self.auditFormData.allPrintAppForm):''

        let {processDefinitionId, taskDefinitionKey, variables, taskId} = processDetail.processDetail.process
        // 处理保存数据
        if(variables[`comment_${taskId}`]) self.taskSaveData.comment = variables[`comment_${taskId}`]
        if(variables[`attachment_${taskId}`]) self.taskSaveData.attachment = variables[`attachment_${taskId}`]

        if(self.uploadPermissionNameOne !== '' && self.uploadPermissionNameTwo !== '') {
          // 判断当前任务是否有上传文件权限
          let uploadPermission = processDetail.processDetail.process.status == 'todo' && processDetail.processDetail.process.assignee == self.userInfo.user_id
          self.permissionList = await self.queryTaskUploadDetail(processDefinitionId, taskDefinitionKey, uploadPermission)
        }
        self.processDetail = processDetail.processDetail?processDetail.processDetail:{}

        // 判断核定额度按钮是否显示
        // let flow = processDetail.processDetail.flow
        let presentFlow = self.flowData[self.flowData.length - 1]
        this.presentFlow = presentFlow
        // self.showQuotaBtn = presentFlow.assigneeName == self.userInfo.user_name && presentFlow
        self.showQuotaBtn = presentFlow.historyActivityId == 'Activity_1v3ge2v' && presentFlow.assigneeName == self.userInfo.user_name

        self.dataReady = true

        // 是否为流程第一步 且 当前为流程发起人本人
        let isFirstFlowPermission = self.flowData[0].assignee == self.userInfo.user_id && self.flowData[0].historyActivityId == presentFlow.historyActivityId
        self.$store.commit('SET_WORKFLOW_STATE', {state: self.auditStatus,isFirstFlowPermission: isFirstFlowPermission})
        self.$forceUpdate()
        resolve()
      })
    },

    /**
     * 部分子公司流程判断
     * 判断是否显示董事长审核
     * @param {Array} keyArray 流程key
     * @param {String} flowName 当前节点名称
     * @param {String} flowId 当前节点id historyActivityId
     */
    showChairmanAudit(keyArray, flowName,flowId) {
      if(this.processDetail.process) {
        const processKey = this.processDetail.process.processDefinitionKey
        const presentFlow = this.flowData[this.flowData.length - 1].historyActivityName
        const historyActivityId = this.flowData[this.flowData.length - 1].historyActivityId
        if( keyArray.includes(processKey) && (flowName == presentFlow||historyActivityId==flowId)) {
          return true
        } else {
          return false
        }
      }
    },
    /**
     * 
     * 判断登陆人是否当前流程的流程人
     * @param {Array} flowNameArray 流程名字Array
     * @param {String} userId 当前登陆人userId
     */
    isFlowConfirm(flowNameArray,userId) {
      const assignee = this.flowData[this.flowData.length - 1].assignee
      const historyActivityName = this.flowData[this.flowData.length - 1].historyActivityName
      if(flowNameArray.includes(historyActivityName) && userId == assignee) {
        return true
      } else {
        return false
      }

    },
    setFinFlow(form) {
      return new Promise(async(resolve, reject) => {
        const processInsId = this.processDetail.process.processInstanceId
        const params = {
          is_chairman_audit: form.is_chairman_audit
        }
        const res = await setFlowParams(processInsId, params)
        if(res.data.code == 200) {
          resolve(true)
        }else {
          resolve(false)
        }
      })
    },


    /**
     * 获取虚拟id
     */
    getVirtualID() {
      return new Promise((resolve, reject) => {
        queryVirtualId().then(res => {
          resolve(res.data.data);
        }).catch(err => {
          reject(err);
        });
      })
    },

    /**
     * 保存流程
     * @param {String} comment 会签意见
     * @param {Object} variables 表单数据
     */
    async flowSaveTask(variables, comment) {
      let processInstanceId = this.processDetail.process.processInstanceId
      let taskId = this.processDetail.process.taskId
      let params = {
        processInstanceId,
        taskId,
        assignee: this.userInfo.user_id,
        variables,
        comment
      }
      new Promise(async(resolve, reject) => {
        let saveRes = await saveTaskProcess(params)
        if(saveRes.data.code == 200){
          this.$message({
            message: '流程保存成功',
            type: 'success'
          })
          resolve(saveRes.data.data)
        }else{
          this.$message({
            message: saveRes.data.mesg,
            type: "warning"
          })
        }
      })

    },


    /**
     * 查询实例运行定义ID
     * @param {*} key 如leave_apply
     */
    userQueryProcessDefinedId(key){
      return new Promise( async(resolve, reject) => {
        let res = await queryProcessDefinedId(key);
        if(res.data.code == 200){
          resolve(res.data.data.records[0].id);
        }else{
          this.$message({
            message: res.data.mesg,
            type: "warning"
          })
        }
      })
    },
    /**
     *  发起流程
     *  @param {string} processId 流程定义ID
     *  @param {string} comment 会签意见
     *  @param {Array} attachmentList 会签意见附件
     *  @param {String} detailFormUrl （必填）流程列表跳转url地址
     *  @param {Boolean} notWithFile  财务不带附件的流程，增加一个节点notWithFile true :不带附件  false:带附件
     *  @param {String} compDeptId    财务流程，增加部门id传参
     *  @param {Boolean} skip         财务流程，保存也会提交流程skip传false
     *  @param {Boolean} skipForce    财务流程，发起流程,跳过第一步skipForce传true
     *  @param {String} fileId        转贷合同流程，合同终止传fileId,(暂时弃用)
     *  @param {String} stopRemark    转贷合同流程，合同终止传stopRemark,(暂时弃用)
     *  @param {String} loanProjectType 资管尽调发起类型 1.委贷 2.定增
     *  @param {String} modelName 发起流程名称
     * */ 
    startWorkFlowProcess({notWithFile,compDeptId,skip,skipForce,processId ,comment ,attachmentList, detailFormUrl,processInstanceName, riskExposure,remark,stopRemark,fileId,loanProjectType,modelName}) {
      return new Promise( async(resolve, reject) => {
        let params = {
          processId: processId,
          comment: comment,
          detailFormUrl,
          processInstanceName,
          riskExposure,
          remark,
          stopRemark,
          fileId,
          skip,
          skipForce,
          compDeptId,
          notWithFile,
          loanProjectType,
          modelName
        }
        if(attachmentList && attachmentList.length > 0){
          params.attachment = attachmentList;
        }
        let startRes = await startProcess(params).catch((error)=>{
          reject(error)
        })
        if(startRes&&startRes.data.code == 200) {
          // 返回流程实例ID 绑定当前任务
          resolve(startRes.data.data)
          this.$message({
            message: '发起流程成功',
            type: 'success'
          })
        }
        // else{
        //   reject(startRes.data.msg)
        // }
      })
    },

    /**
     * 查询任务ID
     * @param {string} processId 流程ID
    */
    queryWorkFlowTaskId(processId) {
      return new Promise( async(resolve, reject) => {
        let params = {
          processId: processId,
        }
        let taskIdRes = await getTaskId(params)
        if(taskIdRes.data.code == 200) {
          resolve(taskIdRes.data.data)
        }else{
          reject(taskIdRes.data.msg)
        }
      })
    },

    /**
     * 查询流程详情
     * @param {string} processId 流程ID
     */
    queryWorkFlowDetail(processId) {
      return new Promise( async(resolve, reject) => {
        let params = {
          processId: processId,
        }
        let detailRes = await workFlowDetail(params)
        if(detailRes.data.code == 200) {
          resolve(detailRes.data.data)
        }else{
          reject(detailRes.data.msg)
        }
      })  
    },

    /**
     * 流程转交下一步
     * @param {string} taskId 任务ID
     * @param {string} processInstanceId 流程实例ID
     * @param {array}  attachment 附件
     * @param {string} comment 会签意见
     * @param {object} variables 表单数据
    */
    taskFlowNext(taskId, processInstanceId, attachment = [], comment = '', variables = {}) {
      let params = {
        taskId: taskId,
        processInstanceId: processInstanceId,
        attachment,
        comment,
        variables,
        pass: true
      }
      return new Promise(async(resolve, reject) => {
        let nextRes = await completeTask(params)
        if(nextRes.data.code == 200) {
          // 关闭标签
          this.$store.commit("DEL_TAG", this.tag);
          if(this.paramsId==='0'||this.paramsId==='-1'){
            this.$router.go(-2) 
          }else {
            this.$router.go(-1)
          }
          
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          // 返回结果
          resolve(nextRes)
        }else{
          this.$message({
            message: nextRes.data.msg,
            type: 'warning'
          })
        }
      })

    },

    zsTaskFlowNext(taskId, processInstanceId, attachment = [], comment = '', variables = {}) {
      let params = {
        taskId: taskId,
        processInstanceId: processInstanceId,
        attachment,
        comment,
        variables,
        pass: true
      }
      return new Promise(async(resolve, reject) => {
        let nextRes = await completeTask(params)
        if(nextRes.data.code == 200) {
          // 关闭标签
          // this.$store.commit("DEL_TAG", this.tag);
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          // 返回结果
          resolve(nextRes)
        }else{
          this.$message({
            message: nextRes.data.msg,
            type: 'warning'
          })
        }
      })

    },


    /**
     * @param {string} taskId 任务ID
     * @param {string} processInstanceId 流程实例ID
     * @param {array}  attachment 附件
     * @param {string} comment 会签意见
     * @param {object} variables 表单数据
     * @param {array} selectPeopleData
     */
    async selectPeopleFlowNext(taskId, processInstanceId, attachment = [], comment = '', variables = {}, taskInfoList) {
      let params = {
        taskId: taskId,
        processInstanceId: processInstanceId,
        taskInfoList: taskInfoList,
        attachment,
        comment,
        variables,
        pass: true
      }
      return new Promise(async(resolve, reject) => {
        let nextRes = await workFlowNext(params)
        if(nextRes.data.code == 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          if(this.$refs.bottomLine){
            this.$refs.bottomLine.closeSelectDialog()
          }
          
          // 返回结果
          resolve(nextRes)
        }else{
          this.$message({
            message: nextRes.data.msg,
            type: 'warning'
          })
        }
      })
    },

    async taskFlowComplete(taskId, processInstanceId) {
      let params = {
        taskId: taskId,
        processInstanceId: processInstanceId,
      }
      let nextRes = await completeTask(params)
      if(nextRes.data.code == 200) {
        this.$message({
          message: '操作成功',
          type: 'success'
        })          
      }else{
        this.$message({
          message: nextRes.data.msg,
          type: 'warning'
        })    
      }
    },

    /***
     * 流程转他人处理
     * @param {string} assignee 接收人ID
     * @param {string} taskId 任务ID
     * @param {string} comment 备注信息
     */
    async taskFlowTransfer({assignee, taskId, comment}) {
      let params = {
        taskId: taskId,
        assignee: assignee,
        comment: comment
      }
      let taskTransferRes = await taskTransfer(params)
      if(taskTransferRes.data.code == 200) {
        this.$message({
          message: '流程转交成功',
          type: 'success'
        })
      }else{
        this.$message({
          message: taskTransferRes.data.msg,
          type: 'error'
        })
      }
    },

    /**
     * 获取流程表单详情
     * @param {string} processId 流程ID
     */
    async queryProcessFormDetail(processId) {
      // return new Promise( async(resolve, reject) => {
        let params = {
          processId: processId,
        }
        let formRes = await processForm(params)
        this.dataReady = true

        if(formRes.data.code == 200) {
          this.uploadPermissionNameOne = formRes.data.data.fileParentName
          this.uploadPermissionNameTwo = formRes.data.data.fileName
          this.flowProcessName = formRes.data.data.process.name
          // resolve(formRes.data.data)
        }
      // })
    },

    /***
     * 流程退回
     * @param {string} nodeId 节点ID
     * @param {string} comment 回退意见
     * @param {string} taskId 任务ID
     */
    taskFlowBack(taskId, nodeId, comment) {
      let params = {
        taskId,
        nodeId,
        comment
      }
      return new Promise(async(resolve, reject) => {
        let res = await rollBackNode(params)
        if(res.data.code == 200) {
          this.$message({
            message: '流程退回成功',
            type: 'success'
          })
          resolve(res)
        }
      })

    },

    /**
     * 查询可回退节点
     * @param {string} taskId 任务ID
     */
    queryBackStepList(taskId) {
      return new Promise( async(resolve, reject) => {
        let params = { taskId: taskId }
        let backStepListRes = await backStepList(params)
        if(backStepListRes.data.code == 200) {
          resolve(backStepListRes.data.data)
        }else{
          this.$message({
            message: backStepListRes.data.msg,
            type: 'warning'
          })
        }
      })      
    },

    /***
     * 流程保存
     * @param {string} taskId 任务ID
     * @param {object} processInstanceId 流程定义ID
     * @param {object} assignee 接收人ID
    */
    async taskFlowSave() {
      let params = {
        processInstanceId: this.processDetail.process.processInstanceId,
        taskId: this.processDetail.process.processInstanceId,
        assignee: this.processDetail.process.assignee
      }
      let saveTaskProcessRes = await saveTaskProcess(params)
      if(saveTaskProcessRes.data.code == 200) {
        this.$message({
          message: '保存成功',
          type: 'success'
        })
      }else{
        this.$message({
          message: saveTaskProcessRes.data.msg,
          type: 'warning'
        })
      }
    },

    /** 
     * 终止流程
     * @param {string} taskId 当前节点ID
    */
    async taskFlowStop(taskId) {
      let params = {
        taskId: taskId,
      }
      return new Promise(async(resolve, reject) => {
        let res = await stopProcess(params)
        if(res.data.code == 200) {
          this.$message({
            message: '流程终止成功',
            type: 'success'
          })
          resolve(res)
        }else{
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })     
    },

    /**
     * 查询当前流程信息
     * @param {string} processId 流程ID
     * @param {string} taskId 实例ID
    */
    async queryProcessDetail(processId, taskId) {
      return new Promise( async(resolve, reject) => {
        let params = {
          processInsId: processId,
          taskId: taskId,
        }
        // let taskIdRes = await processDetail(params)
        let taskIdRes = await processInfo(params)
        if(taskIdRes.data.code == 200) {
          resolve(taskIdRes.data.data)
        }else{
          reject(taskIdRes.data.msg)
        }
      })
    },

    // 生成打印临时option
    handleTemporaryPrintOption(obj) {
      if (!obj.type) return
      obj.span = 24
      if (obj.type == 'dynamic') {
        obj.children.type = 'form'
        obj.children.column.forEach(col => {
          this.handleTemporaryPrintOption(col)
        })
      }
    },    

   /**
    * 查询当前任务节点信息
    * @param {String} processId 当前流程ID
    * @param {String} taskId 当前节点ID taskId为空时 查询第一个任务节点上传文件列表权限
    * @param {Boolean} uploadPermission 是否有文件上传权限
    */
    async queryTaskUploadDetail(processId, taskId = '', uploadPermission) {
      return new Promise( async(resolve, reject) => {
        let params = {
          processDefId: processId,
          taskId: taskId,
        }
        let taskIdRes = await queryUploadFileExtensionElements(params)
        if(taskIdRes.data.code == 200) {
          // 处理节点信息
          let taskDetail = taskIdRes.data.data.elements
          // 循环taskDetail, 将attributes中id,name,readable,writable对象中的value赋值到返回数据的数组中
          let taskDetailArr = []
          taskDetail.forEach(item => {
            let obj = {}
            for(let key in item.attributes) {
              obj[key] = item.attributes[key][0].value
            }
            // uploadPermission为false时, 表示没有文件上传权限
            if(!uploadPermission) {
              obj.writable = 'false'
            }
            taskDetailArr.push(obj)
          })
          resolve(taskDetailArr)
        }else{
          reject(taskIdRes.data.msg)
        }
      })
    },

    /**
     * 详情页查询当前任务节点数据
     * @param {string} processId 当前流程ID
     */
    async queryTaskDetail(processId) {
      return new Promise( async(resolve, reject) => {        
        let params = {
          processId: processId,
        }
        // 查询任务节点数据
        let taskIdRes = await getTaskIdByProcessInsId(params)
        // console.info(taskIdRes, 'getTaskIdByProcessInsId')
        if(taskIdRes.data.code == 200) {
          // 通过taskIdRes.data.data中的ID查询流程详情数据
          let processDetailRes = await processInfo({processInsId:processId, taskId:taskIdRes.data.data})
          // console.info(processDetailRes, 'queryProcessFormDetail')
          if(processDetailRes.data.code == 200) {
            // 处理会签意见数据，循环processDetailRes.data.data中flow，将flow中historyActivityType为userTask的数据提取出来重新组装
            let processDetail = processDetailRes.data.data
            let commentList = []
            let timeArray = []
            let flowDataArray = []
            processDetail.flow.forEach(item => {
              if(item.historyActivityType == 'userTask') {
                let obj = {}
                for(let key in item) {
                  // 会签意见数组
                  obj[key] = item[key]
                  if(key == 'comments' && obj[key].length > 0){
                    obj['commentTime'] = obj[key][0]['time'].substring(0,10)
                    timeArray.push(obj.commentTime)
                  }
                }
                commentList.push(obj)
                // 流程数据数组

                flowDataArray.push(item)
              }
            })
            // 过滤timeArray中重复的时间
            timeArray = Array.from(new Set(timeArray))
            let newCommentList = []
            timeArray.forEach(item => {
              let obj = {}
              obj.time = item
              // 过滤commentList中的commentTime与item相同的数据
              obj.comments = commentList.filter(item => item.commentTime == obj.time)
              newCommentList.push(obj)
            })

            // 赋值当前日期，编辑部分数据
            let newDate = this.setNewDate()
            newCommentList.push({
              time: newDate,
              isEdit: true,
              userName: this.userInfo.user_name
            })

            // 处理流程记录数据, 添加序号, 并根据claimTime判断流程是否已经完成
            let newFlowDataArray = []
            flowDataArray.map((item, index) => {
              if(index == 0) {
                item.claimTime = item.createTime
              }

              /**
               *  判断流程记录状态
               *  存在createTime但claimTime为空时，流程 未接受办理
               *  存在createTime与claimTime，但endTime为空时，流程 办理中
               *  存在createTime与claimTime与endTime，流程 已完成
               * */ 
              if(item.claimTime == '') {
                item.workStatusStr = '未接受办理'
                item.workStatus = '0'
              }else if(item.claimTime != '' && item.endTime == '') {
                item.workStatusStr = '办理中'
                item.workStatus = '1'
              }else {
                item.workStatusStr = '已完成'
                item.workStatus = '2'
              }              
              item.num = index + 1
              newFlowDataArray.push(item)
            })
            // 设置附件路径参数
            if(processDetail.form) {
              this.uploadPermissionNameOne = processDetail.form.fileParentName
              this.uploadPermissionNameTwo = processDetail.form.fileName
            }

            // 处理流程图配置
            let initXml = processDetailRes.data.data.process.versionXml == ''?processDetailRes.data.data.process.xml:processDetailRes.data.data.process.versionXml
            this.bpmnOption = {
              flows: this.handleResolveFlows(processDetailRes.data.data.flow),
              xml: initXml,
              mode: 'view'
            }

            // 处理数据返回
            let returnData = {
              taskId: taskIdRes.data.data,
              processDetail: processDetailRes.data.data,
              commentList: newCommentList,
              flowData: newFlowDataArray,
            }
            resolve(returnData)
          }else{
            reject(processDetailRes.data.msg)
          }
        }else{
          reject(taskIdRes.data.msg)
        } 
      })
    },

    setNewDate() {
      let newDate = new Date()
      return moment(newDate).format("YYYY-MM-DD")
    },

    // 设置流程图flow参数
    handleResolveFlows(flow) {
      const flows = []

      flow.forEach(f => {
        const { assigneeName, createTime, endTime, comments } = f
        const ff = {
          id: f.historyActivityId,
          class: (!endTime && f.historyActivityType != 'candidate') ? 'nodePrimary': ''
        }
        let tooltip = ''
        if (assigneeName) {
          tooltip = `<span title='${assigneeName}'>${assigneeName}</span><br>`
          if (createTime) tooltip += `<span title='${createTime}'>${this.dateFormat(new Date(createTime), 'yyyy-MM-dd hh:mm')}</span><br>`

          if (comments && comments.length > 0) {
            let comment
            let type, fullMessage
            if(comments.length == 1){
              type = comments[0].type
              fullMessage = comments[0].fullMessage
            }else {
              comments.map(item => {
                if(item.type == 'comment') {
                  fullMessage = item.fullMessage
                  type = item.type
                }
              })
            }

            if (type == 'assigneeComment') {
              comment = '变更审核人：' + fullMessage
              ff.class = 'nodeWarn'
            }
            if (type == 'dispatchComment') {
              comment = '调度：' + fullMessage
              ff.class = 'nodeWarn'
            }
            if (type == 'transferComment') {
              comment = '转办：' + fullMessage
              ff.class = 'nodeWarn'
            }
            if (type == 'delegateComment') {
              comment = '委托：' + fullMessage
              ff.class = 'nodeWarn'
            }
            if (type == 'rollbackComment') {
              comment = '驳回：' + fullMessage
              ff.class = 'nodeError'
            }
            if (type == 'terminateComment') {
              comment = '终止：' + fullMessage
              ff.class = 'nodeError'
            }
            if (type == 'addMultiInstanceComment') {
              comment = '加签：' + fullMessage
              ff.class = 'nodeWarn'
            }
            if (type == 'deleteMultiInstanceComment') {
              comment = '减签：' + fullMessage
              ff.class = 'nodeError'
            }
            if (type == 'withdrawComment') {
              comment = '撤销：' + fullMessage
              ff.class = 'nodeWarn'
            }
            if (type == 'comment') {
              comment = '审批：' + fullMessage
              ff.class = 'nodeSuccess'
            }
            tooltip += `<span title='${comment}'>${comment}</span>`
          }
          ff.tooltip = tooltip
        }

        if (f.historyActivityType == 'sequenceFlow') ff.class = 'lineWarn'
        else if (!ff.class && f.historyActivityType != 'candidate') ff.class = 'nodeSuccess'

        const index = flows.findIndex(fl => fl.id == f.historyActivityId)
        if (index != -1) flows.splice(index, 1, ff)
        else flows.push(ff)
      })
      return flows
    },

    workFlowSaveTask() {
      return new Promise(async(resolve, reject) => {
        let taskId = this.processDetail.process.taskId
        // 从vuex中获取
        let comment = this.workFlowData.opinionContent
        // let attachmentList = this.workFlowData.attchmentList

        // 流程表单数据
        let customData = this.$refs.auditInfo.commentDetail
        let formData = this.$refs.auditInfo.$data.formData

        let variables = this.dealAuditForm(formData, customData)
        // 保存数据存储在variables中
        variables[`comment_${taskId}`] = comment
        // variables[`attachment_${taskId}`] = attachmentList

        let saveRes = await this.flowSaveTask(variables)

        resolve(saveRes)
      })
    },



    /**
     *  处理移动端表单配置
     *  @param {Object} allAppForm auditFormData
     *  
     * */ 
    dealMobileFomrConfig(val) {
      let self = this
      let config = JSON.parse(val.allAppForm)
      if(this.status == 'done') {
        config.column.forEach(item => {
          item.disabled = true
        })
      }
      
      if(val.taskForm){
        // 处理绑定数据 提取val中的数据
        config.column.map(item => {
          let filterObj = val.taskForm.filter(obj => {
            return obj.id === item.prop
          })
          if(filterObj&& filterObj.length> 0){
            item.display = filterObj[0].readable?true: false
            item.disabled = filterObj[0].writable?false: true
            item.required = filterObj[0].required?true: false
            // self.formData[item.prop] = filterObj[0].value
            self.$set(self.mobileFormData, item.prop, filterObj[0].value)
            item.variables = filterObj[0].value != ''?JSON.parse(filterObj[0].value).opinionContent:''
            item.sign = filterObj[0].value != ''?JSON.parse(filterObj[0].value).opinionDate:''
            item.value = filterObj[0].value
          }else{
            item.display = false,
            item.disabled = true,
            item.required = false
          }
        })
        // 从val.taskForm中以id为key提取value数据，重组成formData
        val.taskForm.map(item => {
          self.$set(self.mobileFormData, item.id, item.value)
        })
      } else {
        // 无taskForm数据，直接提取process中variables数据，并设置表单为只读
        config.column.map(item => {
          self.$set(self.mobileFormData, item.prop, val.variables[item.prop])
          item.variables = val.variables[item.prop] && val.variables[item.prop] !='' ?JSON.parse(val.variables[item.prop]).opinionContent:''
          item.sign = val.variables[item.prop] && val.variables[item.prop] !='' ?JSON.parse(val.variables[item.prop]).opinionDate: ''
          item.disabled = !self.isEditable
        })
      }
      this.mobileFormConifg = config.column
    },

    /**
     * 保存会签意见
     * @param {String} comment 会签意见
     */
    async saveMobileComment(comment) {
      let taskId = this.processDetail.process.taskId
      let variables = {}
      // 保存数据存储在variables中
      variables[`comment_${taskId}`] = comment

      let saveRes = await this.flowSaveTask(comment,variables)
      if(saveRes.data.code == 200) {
        // this.$notify.success('会签意见保存成功');
        this.$message({
          message: '会签意见保存成功',
          type: 'success'
        })        
      }
    },

    changeFormData(config) {
      // 处理taskForm
      // let copyConfig = JSON.parse(this.auditFormData.allAppForm)
      // copyConfig.column = config
      this.mobileFormChange = config
    },

    // 移动端转交下一步流程
    async flowNextMobile(formData,taskInfoList) {
      let processInsId = this.processDetail.process.processInstanceId
      let taskId = this.processDetail.process.taskId
      // 流程表单数据
      let variables = formData

      // let res = await this.taskFlowNext(
      //     taskId,
      //     processInsId,
      //     this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
      //     this.$refs.commentStep.$data.submitText,
      //     variables
      // )
      let taskName = this.processDetail.process.taskName
      let res= {
        data:{
          code:'',
          msg:'失败'
        }
      }
      if(taskInfoList&&taskInfoList.length>0){
           res= await this.selectPeopleFlowNext(
                taskId,
                taskName,
                this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                variables,
                JSON.stringify(taskInfoList),
            )
        
        }else {
           res= await this.taskFlowNext(
                taskId,
                processInsId,
                this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                variables
            )
        }
      if(res.data.code == 200 ){
        this.$refs.bottoms.closeDialog()
        if(this.refreshData){
          this.refreshData()
        }
        this.$message({
          message: '转交下一步操作成功',
          type: 'success'
        })
      }else{
        // this.$notify.warn(res.data.msg);
        this.$message({
          message: res.data.msg,
          type: 'warning'
        })
      }
    },

  }
}